export enum PATHWAY_STATUSES {
  NOT_WATCHED = 'not-watched',
  STARTED = 'started',
  WATCHED = 'watched',
  HAS_TEST_SCORE = 'has-test-score',
  COMPLETED = 'completed',
}

export enum USER_ROLES {
  CompanyOwner = 'company_owner',
  CompanyManager = 'company_manager',
  TeamManager = 'team_manager',
  B2BLearner = 'b2b_learner',
  B2CLearner = 'b2c_learner',
  LearnerWithoutSubscription = 'learner_without_subscription',
}
